"use strict";
import $ from "jquery";
import readmore from "../lib/readmore";

$("[data-read-more]").each(function() {
  let $this = $(this);
  let moreLinkText = ($this.closest(".PartnerBlock-list").length || $this.closest(".PartnerCard-content").length) ? "Show More" : "Read More";
  //add CSS overflow hidden to the parent element
  $this.css("overflow", "hidden");
  
  // calculate height of child event cards, if any, since they can vary
  if ($this.find(".EventLanding-list-item").length) {
    $this.collapsedHeight = $this.find(".EventLanding-list-item")[0].offsetHeight;
  } else if ($this.find(".PartnerBlock-item").length) {
    // use different collapse heights for mobile and desktop
    if (window.innerWidth <= 579) {
      // show 3 items (plus 2 gaps of 24px each) on mobile
      $this.collapsedHeight = ($this.find(".PartnerBlock-item")[0].offsetHeight * 3) + 48;
    } else {
      // show 2 rows of items (plus gap of 24px) on desktop
      $this.collapsedHeight = ($this.find(".PartnerBlock-item")[0].offsetHeight * 2) + 24;
    }
  } else if ($this.find(".PartnerCard-relatedResources-item").length) {
    // use different collapse heights for mobile and desktop
    if (window.innerWidth <= 799) {
      // show 3 items (plus 3 gaps of 10px each) on mobile
      $this.collapsedHeight = ($this.find(".PartnerCard-relatedResources-item")[0].offsetHeight * 4) + 30;
    } else {
      // show 2 rows of items (plus gap of 25px) on desktop
      $this.collapsedHeight = ($this.find(".PartnerCard-relatedResources-item")[0].offsetHeight * 2) + 25;
    }
  } else if ($this.find(".ArticleNew-relatedArticles-item").length) {
    // use different collapse heights for mobile and desktop
    if (window.innerWidth <= 799) {
      // show 3 items (plus 3 gaps of 10px each) on mobile
      $this.collapsedHeight = ($this.find(".ArticleNew-relatedArticles-item")[0].offsetHeight * 4) + 30;
    } else {
      // show 2 rows of items (plus gap of 25px) on desktop
      $this.collapsedHeight = ($this.find(".ArticleNew-relatedArticles-item")[0].offsetHeight * 2) + 25;
    }
  } else {
    $this.collapsedHeight = 240;
  }

  $this.readmore({
    speed: 500,
    collapsedHeight: $this.collapsedHeight,
    moreLink: `
      <button class="btn-pill btn-pill--expand icon-plus_right">
      ${moreLinkText}
      </button>
    `,

    lessLink: `
      <button class="btn-pill btn-pill--expand icon-minus_right">
        Close
      </button>
    `,

    // beforeToggle: function () {
    //   console.log("before toggle");
    // },

    afterToggle: function (trigger, element, expanded) {
      if (!expanded) {
        // "Close" link was clicked
        $("html, body").animate(
          { scrollTop: element.offset().top },
          { duration: 750 }
        );
      }
    },
  });
})